import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useSession } from '../../hooks/useSession';

// Guard de sesión: sin sesión válida → /login. Mientras resuelve, no
// renderiza datos del panel (spec: nunca contenido antes de autorizar).
export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { session, loading } = useSession();

  if (loading) return null;
  if (!session) return <Navigate to="/login" replace />;
  return <>{children}</>;
}
